import request from '@/utils/request'

export function getOrderByPhone (query) {
  return request({
    url: '/custom/order/phone',
    method: 'get',
    params: query
  })
}
